module.exports = __webpack_public_path__ + "static/media/invite_writer.8b485331.svg";